import React from 'react'
import Coffee from '../images/svg-icons/coffee.svg'
import Microphone from '../images/svg-icons/microphone.svg'
import Flatware from '../images/svg-icons/flatware.svg'
import WineGlass from '../images/svg-icons/wine-glass.svg'
import Volume from '../images/svg-icons/volume.svg'
import Trophy from '../images/svg-icons/trophy.svg'
import UsersClass from '../images/svg-icons/users-class-light.svg'
import Clock from '../images/svg-icons/clock-light.svg'


export default {
  coffee: <Coffee />,
  microfono: <Microphone />,
  posate: <Flatware />,
  aperitivo: <WineGlass />,
  ascolto: <Volume />,
  premio: <Trophy />,
  clock: <Clock />,
  'sponsor-activity': <UsersClass />
};